import React from "react";

const NegativeFaceIcon = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g id="face-sad">
      <g transform="translate(1.5, 1.5)">
        <path id="Fill" opacity="0.12" d="M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z" fill="currentColor" />
      </g>
      <g transform="translate(1, 1)">
        <path id="Icon" d="M11 11C11 11 9.875 9.5 8 9.5C6.125 9.5 5 11 5 11M11.75 5.93C11.4537 6.29375 11.0487 6.5 10.625 6.5C10.2013 6.5 9.8075 6.29375 9.5 5.93M6.5 5.93C6.20375 6.29375 5.79875 6.5 5.375 6.5C4.95125 6.5 4.5575 6.29375 4.25 5.93M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </g>
  </svg>
);

export default NegativeFaceIcon;
